import { StyledSearchIcon, StyledTextInput } from './styles';

export const SearchInput = props => (
  <StyledTextInput
    placeholder='Search'
    startAdornment={<StyledSearchIcon />}
    {...props}
  />
);
